import React from 'react'
import Button from 'blocks.simple/button/button'
import ItemAdvertisingCampaigns from '../../__item/_advertisingCampaigns/catalog__item_advertisingCampaigns'
import { api } from 'core/api/ConnectionManager'
import helpers from 'core/helpers'
import translate from 'core/translate'
import { routes } from 'features/routes'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { changeLocation } from 'features/routes'

export default {
    getMethod: 'getFillersAdBlock',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noAdBlocks'),
    emptyIcon: 'not_allow',
    addItemButton: () => (
        <Button rounded="full_md" onClick={() => changeLocation(`/${routes.addFillersAdBlock.path}`)}>
            {translate('add')}
        </Button>
    ),
    tile: ItemAdvertisingCampaigns,
    settingsPrefixes: 'fillersAdBlocks',
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'title', name: translate('byNameAsc') },
    ],
    viewOptions: () => [
        {
            id: 'tile',
            name: translate('tile'),
            icon: 'tile',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
        {
            id: 'list',
            name: translate('list'),
            icon: 'list',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
    ],
    getItemModel: (dataItem, getSelected) => {
        const item = { ...dataItem }
        item.cover = helpers.getBroadcastCover(item.coverSource)

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    getBackendModel: (item) => {
        return api.send('getFillersAdBlockById', { id: item.id }, { hideLoader: true })
    },
    isEqual: (firstItem, secondItem) => firstItem.id === secondItem.id,
    onCreateListeners: [(cb, clearList) => api.addObserver('fillersAdBlockCreated', cb, clearList)],
    onUpdateListeners: [(cb, clearList) => api.addObserver('fillersAdBlockUpdated', cb, clearList)],
    onDeleteListeners: [(cb, clearList) => api.addObserver('fillersAdBlockDeleted', cb, clearList)],
    fields: () => [{ id: 'title', name: translate('name') }],
    init(callback) {
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        name: ({ cover }, p_) => {
            return null
        },
    },
}
